import React from 'react'
import { CXTopicProps } from '../../types/interface'
import styles from './style.module.css'


const CxTopicBadge = ({topic}: CXTopicProps) => {
    return (
        <p className={`bg-primary badge ${styles.cxTopicBadge} p-2 mb-2`}>
            <i className="bi bi-tag-fill me-1"></i> {topic}
        </p>
    )
}

export default CxTopicBadge
